export function stripHtmlToPlainText(value) {
  if (value === undefined || value === null) {
    return "";
  }

  const str = String(value).trim();
  if (!str) {
    return "";
  }

  if (!str.includes("<") && !str.includes("&")) {
    return str;
  }

  if (typeof document !== "undefined") {
    const el = document.createElement("div");
    el.innerHTML = str;
    return (el.textContent || el.innerText || str).trim();
  }

  return str.replace(/<[^>]*>/g, "").trim();
}

export function getAccessibleFieldLabel(label, fallback = "") {
  const plain = stripHtmlToPlainText(label);
  return plain || fallback;
}

export function getHintButtonAriaLabel(fieldLabel) {
  const plain = getAccessibleFieldLabel(fieldLabel);
  return plain ? `More information about ${plain}` : "More information";
}

export function getOptionAccessibleLabel(optionHtml, index) {
  const plain = stripHtmlToPlainText(optionHtml);
  return plain || `Option ${index + 1}`;
}
